export const API_GET_ALL_ANALYSISLIBRARY = "API_GET_ALL_ANALYSISLIBRARY";
export const API_GET_ALL_ANALYSISLIBRARY_SUCCESS = "API_GET_ALL_ANALYSISLIBRARY_SUCCESS";
export const API_GET_ALL_ANALYSISLIBRARY_FAIL = "API_GET_ALL_ANALYSISLIBRARY_FAIL";

export const API_ADMIN_GET_ALL_ANALYSISLIBRARY = "API_ADMIN_GET_ALL_ANALYSISLIBRARY";
export const API_ADMIN_GET_ALL_ANALYSISLIBRARY_SUCCESS = "API_ADMIN_GET_ALL_ANALYSISLIBRARY_SUCCESS";
export const API_ADMIN_GET_ALL_ANALYSISLIBRARY_FAIL = "API_ADMIN_GET_ALL_ANALYSISLIBRARY_FAIL";

export const API_ADMIN_GET_ANALYSISLIBRARY = "API_ADMIN_GET_ANALYSISLIBRARY";
export const API_ADMIN_GET_ANALYSISLIBRARY_SUCCESS = "API_ADMIN_GET_ANALYSISLIBRARY_SUCCESS";
export const API_ADMIN_GET_ANALYSISLIBRARY_FAIL = "API_ADMIN_GET_ANALYSISLIBRARY_FAIL";

export const API_ADMIN_POST_ANALYSISLIBRARY = "API_ADMIN_POST_ANALYSISLIBRARY";
export const API_ADMIN_POST_ANALYSISLIBRARY_SUCCESS = "API_ADMIN_POST_ANALYSISLIBRARY_SUCCESS";
export const API_ADMIN_POST_ANALYSISLIBRARY_FAIL = "API_ADMIN_POST_ANALYSISLIBRARY_FAIL";

export const API_ADMIN_PATCH_ANALYSISLIBRARY = "API_ADMIN_PATCH_ANALYSISLIBRARY";
export const API_ADMIN_PATCH_ANALYSISLIBRARY_SUCCESS = "API_ADMIN_PATCH_ANALYSISLIBRARY_SUCCESS";
export const API_ADMIN_PATCH_ANALYSISLIBRARY_FAIL = "API_ADMIN_PATCH_ANALYSISLIBRARY_FAIL";

export const API_ADMIN_DELETE_ANALYSISLIBRARY = "API_ADMIN_DELETE_ANALYSISLIBRARY";
export const API_ADMIN_DELETE_ANALYSISLIBRARY_SUCCESS = "API_ADMIN_DELETE_ANALYSISLIBRARY_SUCCESS";
export const API_ADMIN_DELETE_ANALYSISLIBRARY_FAIL = "API_ADMIN_DELETE_ANALYSISLIBRARY_FAIL";

export const ADMIN_INIT_NEW_ANALYSISLIBRARY = "ADMIN_INIT_NEW_ANALYSISLIBRARY";
export const ADMIN_RESET_FOCUS_ANALYSISLIBRARY = "ADMIN_RESET_ANALYSISLIBRARY";

export const API_GET_ANALYSES_COST = "API_GET_ANALYSES_COST";
export const API_GET_ANALYSES_COST_SUCCESS = "API_GET_ANALYSES_COST_SUCCESS";
export const API_GET_ANALYSES_COST_FAIL = "API_GET_ANALYSES_COST_FAIL";

export const API_GET_MATCHING_ANALYSES = "API_GET_MATCHING_ANALYSES";
export const API_GET_MATCHING_ANALYSES_SUCCESS = "API_GET_MATCHING_ANALYSES_SUCCESS";
export const API_GET_MATCHING_ANALYSES_FAIL = "API_GET_MATCHING_ANALYSES_FAIL";

export const RESET_COSTS = "RESET_COSTS";

export const API_GET_ANALYSIS_BY_CATALOG_CODE = "API_GET_ANALYSIS_BY_CATALOG_CODE";

export const API_GET_ANALYSIS_AES_ERRORS = "API_GET_ANALYSIS_AES_ERRORS";
export const API_GET_ANALYSIS_AES_ERRORS_SUCCESS = "API_GET_ANALYSIS_AES_ERRORS_SUCCESS";
export const API_GET_ANALYSIS_AES_ERRORS_FAIL = "API_GET_ANALYSIS_AES_ERRORS_FAIL";
